import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import RunOfficerDashboard from './components/RunOfficerDashboard/RunOfficerDashboard';
import StageEvaluatorDashboard from './components/StageEvaluatorDashboard/StageEvaluatorDashboard';
import DoctorDashboard from './components/DoctorDashboard/DoctorDashboard';
import FieldMonitorDashboard from './components/FieldMonitorDashboard/FieldMonitorDashboard';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const renderDashboard = () => {
    if (user.role === 'ADMIN') {
      return <AdminDashboard user={user} onLogout={handleLogout} />;
    } else if (user.role === 'RUN_OFFICER') {
      return <RunOfficerDashboard user={user} onLogout={handleLogout} />;
    } else if (user.role === 'STAGE_EVALUATOR') {
      return <StageEvaluatorDashboard user={user} onLogout={handleLogout} />;
    } else if (user.role === 'DOCTOR') {
      return <DoctorDashboard user={user} onLogout={handleLogout} />;
    } else if (user.role === 'FIELD_MONITOR') {
      return <FieldMonitorDashboard user={user} onLogout={handleLogout} />;
    }
    return <Login onLoginSuccess={handleLoginSuccess} />;
  };

  return (
    <div className="App">
      {!user ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        renderDashboard()
      )}
    </div>
  );
}

export default App;
